import type { LanguageCode } from "@@/shared/translations/language-code";
import type { Except } from "type-fest";
import type { IsoAndUnixTimestamp } from "../date-time/iso-and-unix";
import type { Email } from "../email";
import type { ImageUrl } from "../images/image-url";
import type { Phone } from "../phone";
import type { UserId } from "../users/user-id";

const ME = "ME";
type ME = typeof ME;

type Me = {
    _id: UserId;
    _type: ME;
    _createdAt: IsoAndUnixTimestamp;
    firstName: string;
    lastName: string;
    scopes: string[];
    email: Pick<
        Email,
        "emailAddress" | "verified" | "categoryTags" | "_createdAt"
    >;
    phone: Pick<
        Phone,
        "phoneNumber" | "verified" | "categoryTags" | "_createdAt"
    >;
    imageUrl?: ImageUrl;
    preferences?: {
        language?: LanguageCode;
    };
};

type CreateMeParams = Except<Me, "_type">;

const createMe = (params: CreateMeParams): Me => {
    return {
        ...params,
        _type: ME,
    };
};

export { createMe, ME };
export type { Me };
